function injectStyle (ssrContext) {
  require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-21d86a76\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../../vue-loader/lib/selector?type=styles&index=0!./Stretch.vue")
}
var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./Stretch.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-21d86a76\"}!../../../vue-loader/lib/selector?type=template&index=0!./Stretch.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-21d86a76",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-loading-spinner/src/components/Stretch.vue
// module id = 665
// module chunks = 0